import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  heatmapTotalPageCount: 0,
  heatmapCurrentPageCount: 0,
  isHeatmapDataAvailable: true,
  isHeatmapModeEnabled: false,
  heatmapTimeFrames: {},
  convertedHeatmapData: null,
  heatmapLoader: true,
  loaderText: "Loading Heatmap..."
};

const heatmapSlice = createSlice({
  name: "heatmap",
  initialState,
  reducers: {
    setHeatmapTotalPageCount: (state, action) => {
      state.heatmapTotalPageCount = action.payload;
    },
    setHeatmapCurrentPageCount: (state, action) => {
      state.heatmapCurrentPageCount = action.payload;
    },
    setIsHeatmapDataAvailable: (state, action) => {
      state.isHeatmapDataAvailable = action.payload;
    },
    setIsHeatmapModeEnabled: (state, action) => {
      state.isHeatmapModeEnabled = action.payload;
    },
    setHeatmapTimeFrames: (state, action) => {
      state.heatmapTimeFrames = action.payload;
    },
    setConvertedHeatmapData: (state, action) => {
      state.convertedHeatmapData = action.payload;
    },
    setHeatmapLoader: (state, action) => {
      state.heatmapLoader = action.payload;
    },
    setLoaderText: (state, action) => {
      state.loaderText = action.payload;
    }
  }
});

export const {
  setHeatmapCurrentPageCount,
  setHeatmapTotalPageCount,
  setIsHeatmapDataAvailable,
  setIsHeatmapModeEnabled,
  setHeatmapTimeFrames,
  setConvertedHeatmapData,
  setHeatmapLoader,
  setLoaderText
} = heatmapSlice.actions;

export default heatmapSlice.reducer;
